import React from 'react';
import {
  getCompletedStudentsForCourse,
  getCompletionRateForCourse,
  getEstimatedStudentsForCourse
} from '../utilities/commissions';

const UdemyStudentEngagement = ({ instructorCourses, selectedCourseId = 'all' }) => {
  const filteredCourses = selectedCourseId === 'all'
    ? instructorCourses
    : instructorCourses.filter((course) => String(course.id) === String(selectedCourseId));

  const totalStudents = filteredCourses.reduce(
    (sum, course) => sum + getEstimatedStudentsForCourse(course),
    0
  );
  const totalCompletedStudents = filteredCourses.reduce(
    (sum, course) => sum + getCompletedStudentsForCourse(course),
    0
  );
  const averageCompletionRate = filteredCourses.length > 0
    ? Math.round(
        filteredCourses.reduce((sum, course) => sum + getCompletionRateForCourse(course), 0) /
        filteredCourses.length
      )
    : 0;
  const completionRate = totalStudents > 0
    ? Math.round((totalCompletedStudents / totalStudents) * 100)
    : averageCompletionRate;
  const avgWatchTime = filteredCourses.length > 0 ? Number((18 + completionRate * 0.65).toFixed(1)) : 0;

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-xl font-bold mb-4">Compromiso de los estudiantes</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium">Tasa de finalizacion</h3>
            <span className="text-sm text-gray-500">Segun cursos completados</span>
          </div>
          <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-purple-600 rounded-full" style={{ width: `${completionRate}%` }}></div>
          </div>
          <div className="text-sm text-gray-500 mt-1">{completionRate}% de los estudiantes termina el curso</div>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium">Tiempo promedio de visualizacion</h3>
            <span className="text-sm text-gray-500">Estimado por estudiante</span>
          </div>
          <div className="text-2xl font-bold">{avgWatchTime} min</div>
          <div className="text-sm text-gray-500 mt-1">{totalCompletedStudents.toLocaleString()} alumnos completaron cursos</div>
        </div>
      </div>
    </div>
  );
};

export default UdemyStudentEngagement;
